import Cookies from 'js-cookie';

function isNewRepo() {
  return Cookies.get('new_repo') === 'true';
}

const UserFeatureHelper = {
  isNewRepo,
};

export default UserFeatureHelper;



// WEBPACK FOOTER //
// ./helpers/user_feature_helper.js